module.exports = __webpack_public_path__ + "static/media/ic_specific_gravity.c349e1be.svg";